import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientImmunizationsSelector } from '../selectors'
import { IPatientImmunizationsState } from '../store/patientImmunizations.types'
import { PatientImmunizationsConstants } from '../store/patientImmunizations.constants'
import { setImmunizations } from '../store/patientImmunizations.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { initialPatientImmunization } from '../store/patientImmunizations.reducers'

export function* removeImmunizationRecord() {
  const immunization: IPatientImmunizationsState = yield select(getPatientImmunizationsSelector)
  const { immunizations, key } = immunization
  try {
    const updatedImmunization = [...immunizations]
    if (updatedImmunization.length > 1) {
      yield put(setImmunizations(updatedImmunization.filter((immune) => immune.key !== key)))
    } else {
      const updatedImmunization = [{ ...initialPatientImmunization() }]
      yield put(setImmunizations(updatedImmunization))
    }
  } catch (e) {
    yield put(throwPcrException(`removeImmunizationRecord() error: ${e}`))
  }
}

export function* removeImmunizationRecordSaga() {
  yield takeLatest([PatientImmunizationsConstants.REMOVE_PATIENT_IMMUNIZATION], removeImmunizationRecord)
}
